import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getIconById, resolveIconId } from './catalog';
import { SVG_ICON_REGISTRY } from './icons/registry';
function FallbackIcon({ size = 24, className = '' }) {
    return (_jsxs("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", className: className, "aria-hidden": "true", children: [_jsx("rect", { x: "3", y: "3", width: "18", height: "18", rx: "3" }), _jsx("line", { x1: "8", y1: "12", x2: "16", y2: "12" })] }));
}
export function AgdysaIcon({ id, size = 24, className = '' }) {
    const resolvedId = resolveIconId(id);
    const entry = getIconById(resolvedId) ?? getIconById(id);
    if (!entry) {
        return _jsx(FallbackIcon, { size: size, className: className });
    }
    const SvgIcon = SVG_ICON_REGISTRY[entry.asset];
    if (!SvgIcon) {
        return _jsx(FallbackIcon, { size: size, className: className });
    }
    return _jsx(SvgIcon, { size: size, className: className });
}
